import React from 'react';
import './StatsSection.css';

const StatsSection = () => {
  const stats = [
    {
      number: '1,150+',
      label: 'EMPLOYEES',
      color: '#f5a623'
    },
    {
      number: '28',
      label: 'BRANCHES',
      color: '#8bc34a'
    },
    {
      number: '₹ 5.5 Cr',
      label: 'ASSETS UNDER MANAGEMENT',
      color: '#f5a623'
    },
    {
      number: '₹ 1.78 Cr',
      label: 'CONSOLIDATED LENDING BOOK',
      color: '#8bc34a'
    }
  ];

  return (
    <section className="stats-section">
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-number">{stat.number}</div>
            <div className="stat-label">{stat.label}</div>
            <div className="stat-underline" style={{ backgroundColor: stat.color }}></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
